import { useState, useCallback } from 'react';
import FteTrackingSearchParams from './FteTrackingSearchParams';

function getInitialSearchItem() {
  const now = new Date();
  const searchItem = new FteTrackingSearchParams();
  searchItem.Year = now.getFullYear();
  searchItem.Month = now.getMonth() + 1;
  return searchItem;
}

export default function useMonthSelector() {
  const [searchItem, setSearchItem] = useState(getInitialSearchItem);

  const changeMonth = useCallback((delta) => {
    setSearchItem((prev) => {
      const next = { ...prev };
      let year = next.Year;
      let month = next.Month + delta;
      if (month < 1) { month = 12; year--; }
      else if (month > 12) { month = 1; year++; }
      next.Year = year;
      next.Month = month;
      return next;
    });
  }, []);

  const refreshSearchItem = useCallback(() => {
    setSearchItem((prev) => ({ ...prev }));
  }, []);

  return { searchItem, setSearchItem, changeMonth, refreshSearchItem };
}
